// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Pc14","title":"Header_title__1Q3Xs","side":"Header_side__2cU5A"};